"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClientEntry = exports.wrapRootElement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const error_boundary_1 = __importDefault(require("@atlaskit/gatsby-theme-brisk/src/components/error-boundary"));
const flag_1 = require("@atlaskit/flag");
const analytics_provider_1 = __importDefault(require("./src/components/analytics-provider"));
const global_error_1 = __importDefault(require("./src/components/global-error"));
const feature_flags_1 = __importDefault(require("./feature-flags"));
const wrapRootElement = ({ element, }) => {
    return (jsx_runtime_1.jsx(analytics_provider_1.default, { children: jsx_runtime_1.jsx(flag_1.FlagsProvider, { children: jsx_runtime_1.jsx(error_boundary_1.default, Object.assign({ fallback: jsx_runtime_1.jsx(global_error_1.default, {}, void 0) }, { children: element }), void 0) }, void 0) }, void 0));
};
exports.wrapRootElement = wrapRootElement;
const onClientEntry = () => {
    try {
        Object.entries(feature_flags_1.default).forEach(([key, value]) => {
            // Initialize if it doesn't exist
            // OR override if the default flag state is true
            // Don't set the item if the user has enabled a flag that is disabled by default
            if (localStorage.getItem(`ff-${key}`) === null || value === true) {
                localStorage.setItem(`ff-${key}`, value);
            }
        });
    }
    catch (err) {
        console.error(err);
    }
};
exports.onClientEntry = onClientEntry;
